import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=ac63a5b8&scoped=true&"
import script from "./SectionList.vue?vue&type=script&lang=js&"
export * from "./SectionList.vue?vue&type=script&lang=js&"
import style0 from "./SectionList.vue?vue&type=style&index=0&id=ac63a5b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac63a5b8",
  null
  
)

export default component.exports